import React from 'react';
import * as Backend from "../backend.js";
import * as util from "../other/util.js";
import shared from "../share/shared.js";

// Allows the player to compose a chat message
class ChatComposeView extends util.GameComponent {
    constructor(props) {
        super(props);

        let player_id = this.props.params.player_id;
        if (player_id) {
            Backend.getPlayerAbstract(player_id, (abstract) => {
                if (abstract.success) {
                    let new_state = Object.assign({}, this.state, { recipients: abstract.player.name })
                    this.setState(new_state);
                }
            });
        }

        this.state = {
            player_id: player_id,
            recipients: "",
            recipients_error: "",
            content: "",
            subject: "",
        };
    }

    render() {
        let recipients_error = this.state.recipients_error;
        let subject_error = this.state.subject_error;
        let content_error = this.state.content_error;

        return (
            <div>
                <h1>Compose Message</h1>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                Recipients:
                            </td>
                            <td>
                                <input value={this.state.recipients}
                                    placeholder="Recipients" type="text" maxLength="10000"
                                    onChange={(event) => {
                                        this.setState(Object.assign({}, this.state, { recipients: event.target.value }))
                                    }} />
                            </td>
                            <td>
                                <div className="warning-text">
                                    {recipients_error}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Subject:
                            </td>
                            <td>
                                <input value={this.state.subject}
                                    placeholder="Subject" type="text" maxLength="10000"
                                    onChange={(event) => {
                                        this.setState(Object.assign({}, this.state, { subject: event.target.value }));
                                    }} />
                            </td>
                            <td>
                                <div className="warning-text">
                                    {subject_error}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Message:
                            </td>
                            <td>
                                <textarea value={this.state.content}
                                    placeholder="Message content" maxLength="131072" rows="15" cols="80"
                                    onChange={(event) => {
                                        if (event.target.value.length <= 131072) {
                                            this.setState(Object.assign({}, this.state, { content: event.target.value }));
                                        }
                                    }} />
                            </td>
                            <td>
                                <div className="boring-info-text">
                                    {this.state.content.length} / 131072
                                </div>
                                <div className="warning-text">
                                    {content_error}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <button className="cool-button" onClick={() => {
                                    this.handleSendClick();
                                }}> Send !
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    handleSendClick() {
        let recipients = this.state.recipients.trim();
        let subject = this.state.subject.trim();
        let content = this.state.content.trim();

        let res = this._isMessageOk(recipients, subject, content);
        if (!this._parseErrorMessages(res)) {
            return;
        }

        Backend.tryChatCreateRoom(recipients.split(',').map(iter => iter.trim()), subject, content, (res) => this.handlePlayerChatComposeResponse(res));
    }

    _isMessageOk(recipients, subject, content) {
        let result = { success: true };

        // Subject
        try {
            shared.validateChatSubject(subject);
        } catch (e) {
            Object.assign(result, { success: false, subject_error: e.details.name });
        }

        // Content
        try {
            shared.validateChatMessage(content);
        } catch (e) {
            Object.assign(result, { success: false, content_error: e.details.name });
        }

        // Recipients
        recipients = recipients.trim();
        if (recipients.length === 0) {
            Object.assign(result, {
                success: false,
                recipients_error: "Need at least one person to send to message to."
            });
        }

        return result;
    }

    _parseErrorMessages(res) {
        console.log("ChatComposeView._parseErrorMessages", res);
        if (res.success) {
            this.setState(Object.assign({}, this.state, { recipients_error: null, subject_error: null, content_error: null }));
        } else {
            this.setState(Object.assign({}, this.state, { recipients_error: res.recipients_error, subject_error: res.subject_error, content_error: res.content_error }));
        }
        return res.success;
    }

    handlePlayerChatComposeResponse(res) {
        if (!this._parseErrorMessages(res)) {
            return;
        }

        this.props.navigate('/game/chat/' + res.chat_id);
    }
}

export default util.withParamsAndNavigation(ChatComposeView);